import { Intl } from '@jetshop/intl';
import React, { useEffect, useState } from 'react';
import useInfinitePagination from './useInfinitePagionation';
import SearchQuery from './SearchQuery.gql';
import ActiveFiltersQuery from '@jetshop/core/components/DynamicRoute/ActiveFiltersQuery.gql';
import { useQuery } from 'react-apollo';
import WindowedPage from '../Layout/WindowedPage/WindowedPage';

const WindowedCategory = ({ result, total, filters, term, loading, path }) => {
  const activeFilterQueryResult = useQuery(ActiveFiltersQuery);
  const activeFilters = activeFilterQueryResult?.data?.activeFilters || null;

  const [cacheHit, setCacheHit] = useState(false);
  useEffect(() => {
    if (loading === true) setCacheHit(true);
  }, [loading, setCacheHit]);

  const infinitePaginationProps = useInfinitePagination({
    queriedProducts: result,
    totalResults: total,
    query: SearchQuery,
    queryVariables: {
      filters: activeFilters,
      term
    }
  });

  return (
    <Intl>
      {t => (
        <WindowedPage
          infinitePaginationProps={infinitePaginationProps}
          cacheHit={cacheHit}
          loading={loading}
          filters={filters}
          title={t('Search results')}
          total={total}
          headerContent={t.rich(
            `Your search for {term} yielded {total} hits.`,
            {
              term: <b key="boldTerm">'{term}'</b>,
              total
            }
          )}
        />
      )}
    </Intl>
  );
};

export default WindowedCategory;
